// Single source of truth for all app-wide constants.
// Never hardcode these values directly in components or services.

export const APP_BASE_URL = 'https://sublingox.com';

// Static files are stored under public/assets and are published at /assets.
export const ASSET_BASE_URL = `${process.env.PUBLIC_URL || ''}/assets`;

export function assetUrl(path = '') {
  if (/^https?:\/\//i.test(path)) return path;
  const cleanPath = String(path).replace(/^\/+/, '').replace(/^assets\//, '');
  return `${ASSET_BASE_URL}/${cleanPath}`;
}

// ── Web pages ─────────────────────────────────────────────────────────────────
export const PRIVACY_URL  = `${APP_BASE_URL}/privacy`;
export const TERMS_URL    = `${APP_BASE_URL}/terms`;
export const CREDITS_URL  = `${APP_BASE_URL}/credits`;
export const CONTACT_URL  = `${APP_BASE_URL}/contact`;

// ── Store links ───────────────────────────────────────────────────────────────
export const PLAY_STORE_URL =
  process.env.REACT_APP_PLAY_STORE_URL ||
  'https://play.google.com/store/apps/details?id=com.subrammiles.sm_language_learning';
// Leave unset until the real App Store listing is published.
export const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL || '';

// ── Gamification defaults ─────────────────────────────────────────────────────
export const DEFAULT_XP_GOAL     = 20;
export const REVIEW_TRIGGER_AT   = 5;   // sessions before showing in-app review prompt

// ── Badge definitions ─────────────────────────────────────────────────────────
// Centralised here so mobile and web descriptions stay in sync. `title` is a
// translation key (see achievements.badges.* in src/i18n/locales/en.json),
// not display text — resolve it with t(badge.title) at render time.
export const BADGES = {
  first_session: { emoji: '🎉', title: 'achievements.badges.first_session'  },
  streak_3:      { emoji: '🔥', title: 'achievements.badges.streak_3'    },
  streak_7:      { emoji: '⚡', title: 'achievements.badges.streak_7'    },
  streak_30:     { emoji: '💎', title: 'achievements.badges.streak_30'    },
  xp_goal_hit:   { emoji: '🏆', title: 'achievements.badges.xp_goal_hit'     },
  xp_100:        { emoji: '⭐', title: 'achievements.badges.xp_100'     },
  xp_1000:       { emoji: '🌟', title: 'achievements.badges.xp_1000'   },
  perfect_quiz:  { emoji: '💯', title: 'achievements.badges.perfect_quiz'   },
  first_conversation: { emoji: '💬', title: 'achievements.badges.first_conversation' },
  listening_streak:   { emoji: '🎧', title: 'achievements.badges.listening_streak'   },
  first_speech:       { emoji: '🎙️', title: 'achievements.badges.first_speech' },
  spoken_100:         { emoji: '🗣️', title: 'achievements.badges.spoken_100' },
};
